import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import SchoolAddressSearch from '../SchoolAddressSearch';
import { InputTypes } from '../../utils/validateFormElement';
import { Events } from '../../utils/dom/html-events';
import { ClassNames } from '../../utils/dom/css-classes';

class SchoolFinder extends FormComponent {
	markup(value, rowData, titleMarkup) {
		return `
      <div class="lta-school-finder u-mb-5">
				<div class="lta-school-finder-title ${ClassNames.Hidden}">${titleMarkup}</div>
                <div class="lta-school-finder--search-input-wrapper">
					<div class="lta-school-finder--search-input u-mb-2"></div>
					<div class="lta-school-finder--search-form-button-wrapper u-flex">
						<button type="button" class="lta-school-finder--search-form-button lta-btn lta-btn--lg lta-btn--link">Can’t find your ${rowData.fieldName}? Enter manually</button>
					</div>
				</div>
				<div class="lta-school-finder--search-result ${ClassNames.Hidden}"></div>
				<div class="lta-school-finder--search-form ${ClassNames.Hidden}">
					<div class="lta-school-finder--search-form-wrapper"></div>
					<div class="lta-school-finder--search-form-button-wrapper u-flex">
						<button type="button" class="lta-school-finder--address-form-button lta-btn lta-btn--lg lta-btn--link">Use ${rowData?.finderType === 'university' ? 'university' : 'school'} look-up search</button>
					</div>
				</div>
      </div>
    `;
	}
	afterRender() {
		this.schoolFinderElement = SelectorEngine.findOne('.lta-school-finder', this.containerEl);
		this.schoolFinderTitle = SelectorEngine.findOne('.lta-school-finder-title', this.schoolFinderElement);
		this.schoolFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-school-finder--search-input-wrapper',
			this.schoolFinderElement
		);
		this.schoolFinderSearchInput = SelectorEngine.findOne(
			'.lta-school-finder--search-input',
			this.schoolFinderSearchInputWrapper
		);
		this.schoolFinderSearchFormButton = SelectorEngine.findOne(
			'.lta-school-finder--search-form-button',
			this.schoolFinderSearchInputWrapper
		);
		this.schoolFinderSearchResult = SelectorEngine.findOne(
			'.lta-school-finder--search-result',
			this.schoolFinderElement
		);
		this.schoolFinderSearchForm = SelectorEngine.findOne('.lta-school-finder--search-form', this.schoolFinderElement);
		this.schoolFinderSearchFormWrapper = SelectorEngine.findOne(
			'.lta-school-finder--search-form-wrapper',
			this.schoolFinderSearchForm
		);
		this.schoolFinderAddressButton = SelectorEngine.findOne(
			'.lta-school-finder--address-form-button',
			this.schoolFinderSearchForm
		);

		this.initSearchInputField();

		EventHandler.on(this.schoolFinderSearchFormButton, Events.Click, () => {
			this.value = undefined;
			this.searchInputTextField.remove();
			this.schoolFinderSearchInputWrapper.classList.add(ClassNames.Hidden);
			this.schoolFinderSearchResult.classList.add(ClassNames.Hidden);
			this.schoolFinderSearchForm.classList.remove(ClassNames.Hidden);
			this.schoolFinderTitle.classList.remove(ClassNames.Hidden);

			this.schoolAddressSearch = new SchoolAddressSearch(this.schoolFinderSearchFormWrapper, {
				data: this.data.addressFormElement
			});
			this.schoolAddressSearch.onChange((value) => {
				this.setupValueObject(value, 'Partially Completed');
			});
		});

		EventHandler.on(this.schoolFinderAddressButton, Events.Click, () => {
			this.value = undefined;
			this.schoolAddressSearch.remove();
			this.initSearchInputField();
			this.schoolFinderSearchInputWrapper.classList.remove(ClassNames.Hidden);
			this.schoolFinderSearchResult.classList.add(ClassNames.Hidden);
			this.schoolFinderSearchForm.classList.add(ClassNames.Hidden);
			this.schoolFinderTitle.classList.add(ClassNames.Hidden);
		});
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.schoolFinderSearchInput, {
			data: {
				...this.data,
				additionalParams: this.data?.additionalSearchParam
			},
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item.schoolName,
				secondLineText: `${item.county}, ${item.postcode}`,
				dataKey: this.data.dataKey,
				dataValue: item.id
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.id === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadSchoolResult(event.value, true);
		});
		this.setupValidateObject();
		if (this.data?.value) {
			this.loadSchoolResult(this.data?.value, false);
		}
	}
	loadSchoolResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
		}
		if (!resultDetails?.schoolName) {
			return;
		}
		this.schoolFinderSearchInputWrapper.classList.add(ClassNames.Hidden);
		this.schoolFinderSearchForm.classList.add(ClassNames.Hidden);
		this.schoolFinderTitle.classList.remove(ClassNames.Hidden);
		this.schoolFinderSearchResult.classList.remove(ClassNames.Hidden);
		this.schoolFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.schoolFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-school-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, Events.Click, () => {
			suggestionAutoSuggestResult.remove();
			this.schoolFinderSearchInputWrapper.classList.remove(ClassNames.Hidden);
			this.schoolFinderTitle.classList.add(ClassNames.Hidden);
			this.schoolFinderSearchForm.classList.add(ClassNames.Hidden);
			this.schoolFinderSearchResult.classList.add(ClassNames.Hidden);
		});
	}
	renderAutoSuggestResult(schoolDetail) {
		return `<div class="lta-autosuggest-input-result">
					<p class="lta-text-input__label">Your school</p>
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_school-name u-h6 u-mb-1">${schoolDetail.schoolName}</div>
						<div class="u-body2 u-mb-2">
							${schoolDetail.address.street} ${schoolDetail.address.city} ${schoolDetail.address.state}
							<br>${schoolDetail.county}
							<br>${schoolDetail.postcode}
						</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-school-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
							</svg>Search again
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
		this.searchInputTextField.validate();
		if (this.schoolAddressSearch) {
			this.schoolAddressSearch.validate();
		}
	}
}
export default SchoolFinder;
